import { render } from "./Review.vue?vue&type=template&id=412af4ee&scoped=true"
import script from "./Review.vue?vue&type=script&lang=js"
export * from "./Review.vue?vue&type=script&lang=js"

import "./Review.vue?vue&type=style&index=0&id=412af4ee&lang=scss"
import "./Review.vue?vue&type=style&index=1&id=412af4ee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-412af4ee"]])

export default __exports__